/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Method_AppleInputs */



/**
* | output |
* | --- |
* | "Apple account (SSO)" |
*
* @param {Members_Add_Method_AppleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_method_apple = /** @type {((inputs?: Members_Add_Method_AppleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Method_AppleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Apple-Konto (SSO)")
	return /** @type {LocalizedString} */ ("Apple account (SSO)")
});